import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import AllProduct from "../components/AllProduct";
import FooterOne from "../components/FooterOne";

const AllProductPage = () => {
  return (
    <>
      <Preloader />
      <HeaderOne />
      <AllProduct />
      <FooterOne />
    </>
  );
};

export default AllProductPage;
